import { render } from "./SelectRegimeComponent.vue?vue&type=template&id=75c76cc0&scoped=true"
import script from "./SelectRegimeComponent.vue?vue&type=script&lang=js"
export * from "./SelectRegimeComponent.vue?vue&type=script&lang=js"

import "./SelectRegimeComponent.vue?vue&type=style&index=0&id=75c76cc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c76cc0"]])

export default __exports__